import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Note: PWA service worker registration happens AFTER login in AuthContext,
// so unauthenticated visitors don't get an "Install app" prompt.
